export type BaseAsset = {
  name: string;
  id: string;
  children?: Array<BaseAsset>;
  has_subitems: boolean;
  external_id: string | null;
};

export type SimpleAsset = {
  id: string;
  name: string;
};

export type FlatAsset = {
  name: string;
  id: string;
  parentId: string | null;
};

export type AssetTree = { items: BaseAsset[] };

export type Asset = { name: string; id: string; health_score: string; has_subitems: boolean };

export type OverviewAsset = {
  name: string;
  description: string;
  id: string;
  health: string;
  has_subitems: boolean;
};
export type KPIInfo = {
  delta?: string | null;
  unit_of_measurement: string;
  value: number;
  name: string;
  decimal_places: number;
};
export type AssetDetails = {
  asset: {
    name: string;
    id: string;
    health: string;
    has_sub_items: boolean;
    equipment_summary: {
      name: string;
      value: string;
      unit_of_meansurement: string;
      delta: string;
    }[];
    categories: { [key: string]: number };
    is_root?: boolean;
    kpi?: KPIInfo[];
  };
};

export type AssetSubItem = OverviewAsset & {
  alarms: { open: number; closed: number; investigating: number };
  sensors?: { active: number; delay: number; no_data: number };
  kpi?: KPIInfo[];
};

export type AssetSubItems = {
  assets: AssetSubItem[];
};

export type AssetSubitems = { subitems: { name: string; id: string; has_subitems: boolean }[] };

export type AssetModel = {
  created_date: string;
  covered_asset: string;
  covered_asset_part: string;
  description: string;
  id: number;
  label: string;
  model_subtag_division: string | null;
  name: string;
  subtag: string;
  type: string;
  version: number;
};

export type AssetRertSummary = {
  health_score?: number;
  summary: {
    ALARM_CONDITION: number;
    CRITICAL_CONDITION: number;
    NORMAL_CONDITION: number;
    POTENTIAL_PROBLEM: number;
  };
  total: number;
};

export enum Severity {
  VERY_HIGH = 'VERY_HIGH',
  HIGH = 'HIGH',
  MEDIUM = 'MEDIUM',
  LOW = 'LOW',
}

export enum Classification {
  NOT_USEFUL = 'NOT_USEFUL',
  USEFUL = 'USEFUL',
}

export enum Status {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
}

export enum ActionStatus {
  INVESTIGATING = 'INVESTIGATING',
  ACTION_ISSUED = 'ACTION_ISSUED',
  COMPLETED = 'COMPLETED',
  CANCELED = 'CANCELED',
}

export enum AssetConditionEvaluation {
  CRITICAL_CONDITION = 'CRITICAL_CONDITION',
  POTENTIAL_PROBLEM = 'POTENTIAL_PROBLEM',
  ALARM_CONDITION = 'ALARM_CONDITION',
  NORMAL_CONDITION = 'NORMAL_CONDITION',
}
